import { render, staticRenderFns } from "./NTable.vue?vue&type=template&id=f41e1b6a&scoped=true&"
import script from "./NTable.vue?vue&type=script&lang=js&"
export * from "./NTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41e1b6a",
  null
  
)

export default component.exports